var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan-add-package"},[(_vm.visiableInput)?_c('scan-basic-input',_vm._b({},'scan-basic-input',_vm.addPackageProps,false)):_vm._e(),_vm._v(" "),_c('crudDataTable',_vm._b({model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},'crudDataTable',_vm.tableProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }